'use strict';

/** Use the backend's safe explanation, keeping older task records readable. */
function taskErrorMessage(results) {
  if (!results || typeof results !== 'object') return '';
  for (const field of ['message', 'error', 'reason']) {
    const value = results[field];
    if (typeof value === 'string' && value.trim()) return value.trim();
  }
  return '';
}

module.exports = { taskErrorMessage };
